import { FilterIcon2, PostPaidDashIcon, RefreshIcon, SalesIcon, VendingDashIcon, VendingFailedIcon, VendingPendingIcon, VendingSuccessIcon } from "../../../../assets/icons";
import Button from "../../../../common/components/xepp/button/Button";
import { BillsDashboardTable } from "./bills-dashboard-table/BillsDashboardTable";
import styles from "./BillsDashboard.module.scss";
import gridStyles from "../../../../common/components/xepp/dashboard-card/DashboardCard.module.scss";
import { DashboardCard, DashboardCardTypes } from "../../../../common/components/xepp/dashboard-card/DashboardCard";
import { useConfigLayout } from "../../../../hooks/useConfigLayout";
export const BillsDashboard = () => {
   useConfigLayout({ showBreadCrumb :false, showCountrySelector: false,  utility: null, showExportButton: false });
	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<h3 className={styles.userName}>Welcome Tobiloba,</h3>
				<p className={styles.userIns}>Check out the Latest Activities</p>
			</div>
			<div className={styles.bodyContainer}>
				<div className={styles.sectionHeader}>
					<div>
						<h3 className={styles.sectionTitle}>Overview</h3>
						<p className={styles.sectionSubTitle}>Track your transactions at a glance</p>
					</div>
					<div className={styles.filterRow}>
						<div className={styles.filterItem}>
							<p className={styles.filterLabel}> Country </p>
							<Button variant="outline" leftIcon={<FilterIcon2 style={{ marginRight: 3 }} />} text="Add Filter" />
						</div>
						<div className={styles.filterItem}>
							<p className={styles.filterLabel}> Date </p>
							<Button variant="outline" leftIcon={<FilterIcon2 style={{ marginRight: 3 }} />} text="Add Filter" />
						</div>
					</div>
				</div>
				<div className={gridStyles.dashboardGrid}>
					<DashboardCard
						amount={"NGN 230,000:00"}
						title="Total Sales in Amount"
						className={DashboardCardTypes.YELLOW_CARD}
						icon={<SalesIcon />}
						refreshIcon={<RefreshIcon color="#000" width={14} height={14} />}
					/>
					<DashboardCard
						amount={"500,000"}
						title="Total Number of Vending Transaction"
						className={DashboardCardTypes.LIGHT_BLUE_CARD}
						icon={<VendingDashIcon />}
					/>
					<DashboardCard
						amount={"125,000"}
						title="Total Number of Postpaid Bills Payment"
						className={DashboardCardTypes.BLUE_CARD}
						icon={<PostPaidDashIcon />}
					/>
                    <DashboardCard
						amount={"4533"}
						title="Successful Vending Event"
						className={DashboardCardTypes.GREEN_CARD}
						icon={<VendingSuccessIcon />}
					/>
                    <DashboardCard
						amount={"7"}
						title="Failed Vending Event"
						className={DashboardCardTypes.RED_CARD}
						icon={<VendingFailedIcon />}
					/>
                    <DashboardCard
						amount={"10"}
						title="Pending Vending Event"
						className={DashboardCardTypes.ORANGE_CARD}
						icon={<VendingPendingIcon />}
					/>
				</div>
				<div className={styles.sectionHeader}>
					<div>
						<h3 className={styles.sectionTitle}>Ranking Sales</h3>
						<p className={styles.sectionSubTitle}>Top Sales Rankings</p>
					</div>
					<div className={styles.filterRow}>
						<div className={styles.filterItem}>
							<p className={styles.filterLabel}> Date </p>
							<Button variant="outline" leftIcon={<FilterIcon2 style={{ marginRight: 3 }} />} text="Add Filter" />
						</div>
						<div className={styles.filterItem}>
							<Button variant="outline" text="Export" />
						</div>
					</div>
				</div>
				<BillsDashboardTable />
			</div>
		</div>
	);
};
